import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=7bc6c10c&scoped=true"
import script from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=7bc6c10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6c10c",
  null
  
)

export default component.exports